module.exports = __webpack_public_path__ + "static/033-71c10a6c7544edf47b4422d879240771.jpg";